<template>
  <div v-if="isShow && dataValue.statusType != 3" class="recommendDialog">
    <div class="recommend">
      <!-- 装饰图标 -->
      <img
        class="icon_left"
        src="@/assets/imgs/couponImg/coupon_icon1.png"
        alt="图标"
      />
      <img
        class="icon_top"
        src="@/assets/imgs/couponImg/coupon_icon2.png"
        alt="图标"
      />
      <template v-if="dataValue.statusType == 1">
        <div class="recommend-content">
          <div class="recommend-content-left">
            <span v-if="dataValue.type == 1" class="money">¥</span>
            <span>{{
              formatNumber(dataValue.face_value, dataValue.type)
            }}</span>
            <span v-if="dataValue.type == 2" class="money">折</span>
          </div>
          <div class="recommend-content-right">
            <div class="recommend-content-right-title">
              {{ dataValue.name }}
            </div>
            <div class="recommend-content-right-time">
              <span class="time">{{ handleTime(dataValue.start_time) }}</span>
              <span>-</span>
              <span class="time">{{ handleTime(dataValue.end_time) }}</span>
            </div>
          </div>
        </div>
        <!-- 使用规则 -->
        <div class="rule-text" v-if="dataValue.description">
          {{ `使用规则：${dataValue.description}` }}
        </div>
        <div class="recommend-btn">
          <div class="btn immediatelyGet" @click="receiveCoupon()"></div>
        </div>
      </template>
      <template v-else>
        <div class="recommend-content content2">
          <div class="recommend-content-content">
            <div class="recommend-content-left">
              <span v-if="dataValue.type == 1" class="money">¥</span>
              <span>{{
                formatNumber(dataValue.face_value, dataValue.type)
              }}</span>
              <span v-if="dataValue.type == 2" class="money">折</span>
            </div>
            <div class="recommend-content-right">
              <div class="recommend-content-right-title">
                {{ dataValue.name }}
              </div>
              <div class="recommend-content-right-time">
                <span class="time">{{ handleTime(dataValue.start_time) }}</span>
                <span>-</span>
                <span class="time">{{ handleTime(dataValue.end_time) }}</span>
              </div>
            </div>
          </div>
          <div class="checkCode">
            <p>
              核销码：<span>{{ dataValue.verification_code }}</span>
            </p>
            <div class="operation">
              <img
                src="@/assets/imgs/couponImg/copy.png"
                @click="copyTextTap(dataValue.verification_code)"
                alt="复制"
              />
            </div>
          </div>
        </div>
        <!-- 使用规则 -->
        <div class="rule-text" v-if="dataValue.description">
          {{ `使用规则：${dataValue.description}` }}
        </div>
        <!-- 按钮 -->
        <div class="recommend-btn">
          <div class="btn goUse" @click="gotoUse()"></div>
        </div>
      </template>
    </div>
    <div style="text-align: center; margin-top: 16px">
      <img
        src="@/assets/imgs/couponImg/close_img.png"
        style="cursor: pointer"
        @click="close"
        alt=""
        srcset=""
      />
    </div>
    <couponsProductDialog
      ref="couponsProductDialog"
      :dialogVisible="isCouponProductDialog"
      :goodsList="goodsList"
      :channelId="channelId"
      :fans_id="fans_id"
      @showGoodsQrCode="showGoodsQrCode"
      @close="proDuctClose"
    />
  </div>
</template>

<script>
import tool from "@/kits/Tools.js";
import qs from "qs";
import couponsProductDialog from "./couponsProductDialog";
import { formatNumber, compareDate } from "@/utils";
export default {
  name: "Recommend",
  components: { couponsProductDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    couponTuijianData: {
      type: Object,
      default() {
        return {};
      },
    },
    dsId: {
      type: null,
      default: "",
    },
    channelId: {
      type: String,
      default: "",
    },
    fans_id: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      status: 2,
      isCouponProductDialog: false,
      goodsList: [],
      saveData: {},
    };
  },
  computed: {
    isShow: {
      get() {
        return this.dialogVisible;
      },
      set() {
        this.close();
      },
    },
    dataValue() {
      return { ...this.couponTuijianData, ...this.saveData };
    },
  },
  methods: {
    handleTime(time) {
      if (time) {
        const timeArr = time.split(" ");
        const newTimeArr = timeArr[0].split("-");
        return newTimeArr.join(".");
      }
    },
    formatNumberyi(item) {
      return item.substring(0, 10);
    },
    formatNumber,
    receiveCoupon() {
      var params = {
        coupon_id: this.dataValue.id,
        live_type: 1,
        live_id: this.dsId,
        channel_id: this.channelId,
      };
      this.axios
        .post(
          tool.getTestSchoolApi() + "/fansCoupon/receiveCoupon",
          qs.stringify(params)
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("领取成功");
            this.saveData = res.data.data;
            this.$set(this.saveData, "statusType", 2);
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    gotoUse() {
      if (!compareDate(this.dataValue.start_time)) {
        this.$message({
          type: "error",
          message: "活动暂未开始，请耐心等待",
        });
        return;
      }
      if (compareDate(this.dataValue.end_time)) {
        this.$message({
          type: "error",
          message: "优惠券已过期",
        });
        return;
      }
      if (this.dataValue.goods_list && this.dataValue.goods_list.length > 0) {
        this.isCouponProductDialog = true;
        this.goodsList = this.dataValue.goods_list;
      } else {
        this.$message.error("请联系老师进行使用");
      }
    },
    copyTextTap(text) {
      // 复制过滤
      // eslint-disable-next-line no-useless-escape
      let reg = /\<a(.*?)\>(\S*)\<\/a>/;
      let resultArr = text.match(reg);
      if (resultArr && resultArr[2]) {
        text = resultArr[2];
      }

      var oInput = document.createElement("input"); // 创建一个隐藏input（重要！）
      oInput.value = text; // 赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    proDuctClose() {
      this.isCouponProductDialog = false;
    },
    showGoodsQrCode(id) {
      this.$emit("showGoodsQrCode", id);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.recommendDialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: auto;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.recommend {
  width: 279px;
  max-height: 355px;
  min-height: 286px;
  background: url("~@/assets/imgs/couponImg/coupon_con_bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  box-sizing: border-box;
  position: relative;
}
.icon_left {
  position: absolute;
  top: 170px;
  left: -20px;
}
.icon_top {
  position: absolute;
  top: 22px;
  right: -10px;
}
.recommend-content {
  display: flex;
  width: 249px;
  height: 96px;
  background: url("~@/assets/imgs/couponImg/coupon2.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}
/* 带核销码图片 */
.content2 {
  height: 135px !important;
  flex-direction: column;
  background: url("~@/assets/imgs/couponImg/coupon1.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}
/* 带核销码上部分 */
.recommend-content-content {
  display: flex;
  height: 90px;
}
.recommend-content-left {
  width: 88px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 30px;
  font-family: Source Han Sans CN, Source Han Sans CN-500;
  font-weight: 500;
}

.recommend-content-left .money {
  font-size: 14px;
  height: 28px;
  line-height: 36px;
  font-family: Source Han Sans CN, Source Han Sans CN-700;
  font-weight: 700;
}

.recommend-content-right {
  width: 146px;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.recommend-content-right-title {
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
  line-height: 18px;
}
.recommend-content-right-time {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #fff;
}
/* 使用规则 */
.rule-text {
  width: 240px;
  max-height: 46px;
  overflow-y: hidden;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #fc692f;
  line-height: 14px;
}
/* 按钮 */
.recommend-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.recommend-btn .btn {
  cursor: pointer;
  width: 158px;
  height: 46px;
  margin-bottom: 20px;
  margin-top: 10px;
}
.immediatelyGet {
  background: url("~@/assets/imgs/couponImg/immediatelyGet.png") no-repeat;
  background-size: 100% 100%;
}
.goUse {
  background: url("~@/assets/imgs/couponImg/goUse.png") no-repeat;
  background-size: 100% 100%;
}

/* 核销码 */
.checkCode {
  height: 42px;
  box-sizing: border-box;
  display: flex;
}
.checkCode p {
  padding-left: 13px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
}
.checkCode .operation {
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.checkCode .operation img {
  cursor: pointer;
  margin: 0 5px;
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/couponsComponents/recommend.vue